<div class="u-shadow-mini {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span class="sub-title">Impressions by Time of Day {{ timezone }}</span>
				<span>
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV()"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content" style="position: relative; z-index: 0">
			<span class="sub-title" style="display: none" *ngIf="hasData">Impressions by Time of Day {{ timezone }}</span>
			<div class="o-stack o-stack--nowrap o-stack--center ht-100">
				<div class="chart-container" style="min-height: 200px; width: 100%">
					<div class="chart-wrapper" *ngIf="hasData">
						<div class="chart-inner" *ngFor="let item of chartData">
							<div class="each-daytime">
								<div class="daypart-name">{{ item.daypart }}</div>
								<div class="outer-chart" style="width: 100%">
									<div
										class="inner-chart"
										style="width: {{ item.percent }}%"
										appTooltip
										[attr.title]="
											'<div>' +
											item.daypart +
											'</div><div>' +
											item.friendly_name +
											'</div><div>' +
											(item.impressions | formatNumber) +
											'</div>'
										"
										data-size="small"
										[options]="tooltipOptions"
									></div>
								</div>
							</div>
						</div>
					</div>
					<div class="no-data-text" style="position: absolute; top: calc(50% - 10px); left: 40%" *ngIf="!hasData">
						{{ nodatamessage != 'null' ? nodatamessage : 'No Data Available' }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
